import React, { useCallback, useState } from 'react'
import { Autocomplete } from '@ui-library/core'
import { debounce } from 'throttle-debounce'
import fetchLocations from './fetchLocations'

export const AutocompleteAddressInput = ({ label, onSelect, name }) => {
  const autocompleteUrl = 'https://autocomplete.svc.groupe-seloger.com/api/v2.0/auto/complete/fra/11/10/8/SeLoger'

  const [list, setList] = useState([])
  const [address, setAddress] = useState(undefined)
  let addressData = []

  const onUpdate = useCallback(
    debounce(350, (inputAddress, updateList) => {
      if (inputAddress.trim() === '') return

      fetchLocations(autocompleteUrl, inputAddress).then(newList => {
        addressData = newList
        updateList(newList)
      })
    }),
    [setList, addressData],
  )

  const onSelectValue = useCallback(
    (addressValue, e, setFieldValue) => {
      setAddress(addressValue)
      setFieldValue(addressValue)
      onSelect(addressValue, name)
    },
    [onSelect, name],
  )

  return (
    <Autocomplete
      value={address}
      label={label}
      list={list}
      onUpdate={onUpdate}
      onSelect={onSelectValue}
      placeholder="Saisir une adresse"
      listAlignment="left"
      clearable
      mobileMode={false}
      showList
      testID="autocompleteAdress"
      style={{
        zIndex: 2,
      }}
    />
  )
}
